module.exports = __webpack_public_path__ + "images/exams-and-certification-ds.webp";